import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';

import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { IconButton, Typography } from '@material-ui/core';
import SelectAllIcon from '@material-ui/icons/SelectAll';
import Spinner from '../../UI/Spinner/Spinner';

const IndicadoresConfig = (props) => {
  const { indicadores, loading, onChangeValue, onLoad, seleccionarTodos, deseleccionarTodos } = props;

  const [seleccionarTodoCheck, setSeleccionarTodoCheck] = useState(null);
  const [indicadoresLocal, setIndicadoresLocal] = useState([]);
  const [loadingLocal, setLoadingLocal] = useState(false);

  useEffect(() => {
    setIndicadoresLocal(indicadores.filter((ind) => ind.dashboard === true));
    return () => setIndicadoresLocal([]);
  }, [indicadores, loading]);

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    enviarValoresTrue(indicadores);
  }, [loading]);

  const enviarValoresTrue = (indicadores) => {
    var arr = [];
    indicadores.map((indicador) => {
      if (indicador.estaOculto && indicador.dashboard) {
        return arr.push(indicador);
      }
      return undefined;
    });

    props.configInicial(arr);
  };

  const onSeleccionarTodosClick = () => {
    setLoadingLocal(true);

    var formatIndicadoresFalse = [];
    seleccionarTodos();
    setSeleccionarTodoCheck(false);
    indicadores.map((indicador) => {
      return formatIndicadoresFalse.push({ ...indicador, estaOculto: false });
    });
    setIndicadoresLocal(formatIndicadoresFalse);
    setTimeout(() => setLoadingLocal(false), 500);
  };

  const onDeseleccionarTodosClick = () => {
    setLoadingLocal(true);
    var arr = [];
    var formatIndicadoresTrue = [];
    indicadores.map((indicador) => {
      if (indicador.dashboard) {
        arr.push(indicador);
        return formatIndicadoresTrue.push({ ...indicador, estaOculto: true });
      } else {
        return undefined;
      }
    });
    setSeleccionarTodoCheck(true);
    deseleccionarTodos(arr);
    setIndicadoresLocal(formatIndicadoresTrue);
    setTimeout(() => setLoadingLocal(false), 500);
  };

  const buildSeleccionarTodoButton = () => {
    const verifyTodoSeleccionado = indicadoresLocal.filter((comp) => comp.estaOculto === false);
    const verifyTodoDeseleccionado = indicadoresLocal.filter((comp) => comp.estaOculto === true);
    const verifySeleccionadoMayor = verifyTodoSeleccionado.length > verifyTodoDeseleccionado.length;

    return (
      <div>
        <IconButton
          onClick={
            seleccionarTodoCheck === null
              ? verifyTodoSeleccionado.length === indicadoresLocal.length
                ? () => onDeseleccionarTodosClick()
                : verifyTodoDeseleccionado.length === indicadoresLocal.length
                ? () => onSeleccionarTodosClick()
                : verifySeleccionadoMayor
                ? () => onDeseleccionarTodosClick()
                : () => onSeleccionarTodosClick()
              : seleccionarTodoCheck
              ? () => onSeleccionarTodosClick()
              : () => onDeseleccionarTodosClick()
          }
        >
          <SelectAllIcon style={{ color: seleccionarTodoCheck && 'rgb(9, 212, 255)' }} />
        </IconButton>
        <Typography variant="button">
          {seleccionarTodoCheck === null
            ? verifyTodoSeleccionado.length === indicadoresLocal.length
              ? 'Deseleccionar todos'
              : verifyTodoDeseleccionado.length === indicadoresLocal.length
              ? 'Seleccionar todos'
              : verifySeleccionadoMayor
              ? 'Deseleccionar todos'
              : 'Seleccionar todos'
            : seleccionarTodoCheck
            ? 'Seleccionar todos'
            : 'Deseleccionar todos'}
        </Typography>
      </div>
    );
  };

  const formateoIndicadores = () => {
    const formateoIndicadores = [];
    for (
      var i = 0;
      i <= indicadoresLocal.filter((ind) => ind.esMultiempresa === false && ind.dashboard === true).length / 12;
      i++
    ) {
      formateoIndicadores.push(
        indicadoresLocal
          .filter((ind) => ind.esMultiempresa === false && ind.dashboard === true)
          .slice(i * 12, i * 12 + 12)
      );
    }

    return (
      <div style={{ display: 'flex' }}>
        {formateoIndicadores.map((indicadores, key) => (
          <div key={key} style={{ display: 'flex', flexDirection: 'column', width: '300px' }}>
            {indicadores.map((indicador, key) => (
              <FormControlLabel
                key={key}
                control={
                  <Switch key={key} defaultChecked={!indicador.estaOculto} onChange={() => onChangeValue(indicador)} />
                }
                label={indicador.nombre.trim()}
              />
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div style={{ minHeight: loading || loadingLocal ? '205px' : '0px' }}>
      {!loading && !loadingLocal && buildSeleccionarTodoButton()}
      {loading || loadingLocal ? (
        <Spinner />
      ) : (
        <FormControl component="fieldset">
          <FormGroup>{formateoIndicadores()}</FormGroup>
        </FormControl>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    indicadores: state.configuraciones.indicadoresPorUsuario.indicadores,
    loading: state.configuraciones.indicadoresPorUsuario.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoad: () => dispatch(actions.loadIndicadores())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicadoresConfig);
